import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';

import { GetPatientDetailDialogDocument } from '~/graphql/generated/graphql';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';

export const useFetchPatient = () => {
  const { patientId } = useAtomValue(patientDetailDialogState);

  const [getProfile, { data, loading }] = useLazyQuery(GetPatientDetailDialogDocument);

  const patient = useMemo(() => {
    const _patient = data?.node?.__typename === 'Patient' ? data.node : undefined;
    const _webVisitor = data?.node?.__typename === 'WebVisitor' ? data.node : undefined;
    const _directVisitor = data?.node?.__typename === 'DirectVisitor' ? data.node : undefined;
    const _lineVisitor = data?.node?.__typename === 'LineVisitor' ? data.node : undefined;

    return _patient || _webVisitor || _directVisitor || _lineVisitor;
  }, [data?.node]);

  useEffect(() => {
    if (patientId) {
      getProfile({
        variables: {
          id: patientId,
        },
      });
    }
  }, [getProfile, patientId]);

  return { patient, loading };
};
